import React, { useMemo } from "react";
import { cn } from "@utils";

function CircularSpinner({
  size = 26,
  strokeWidth = 3,
  progressColorClass = "text-violet-500",
  trackColorClass = "text-transparent",
  className = "bg-black rounded-full",
  segmentAngle = 110,
  durationMs = 1000,
}) {
  const radius = (size - strokeWidth) / 2;
  const circumference = useMemo(() => 2 * Math.PI * radius, [radius]);
  const clampedAngle = Math.max(1, Math.min(359, Number(segmentAngle) || 110));
  const segmentLength = useMemo(
    () => (circumference * clampedAngle) / 360,
    [circumference, clampedAngle]
  );

  return (
    <div
      className={cn(
        "relative grid place-items-center",
        className,
        "bg-black rounded-full"
      )}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    >
      <svg width={size} height={size} className="rotate-[-90deg]" aria-hidden>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          className={cn(trackColorClass)}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          fill="none"
        />

        <g
          className="animate-circular-rotate"
          style={{
            transformOrigin: "50% 50%",
            ["--spinner-duration"]: `${durationMs}ms`,
          }}
        >
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            className={cn(progressColorClass)}
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            fill="none"
            strokeDasharray={`${segmentLength} ${circumference}`}
          />
        </g>
      </svg>
    </div>
  );
}

export default CircularSpinner;
